import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Rem from './plugins/rem'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Rem)
new Vue({
  router,
  store,
  render: function (h) { return h(App) },
  created() {
    document.title = '三明农科院';
  }
}).$mount('#app')



// 字体大小 = 667 / 375 * 16
function calcSize() {
  var width = document.documentElement.clientWidth;

  // 设置html根标签的fontSize属性
  var html = document.querySelector("html");
  if (width >= 480) {
    html.style.fontSize = 16 + "px";
  } else if (width >= 375 && width < 480) {
    html.style.fontSize = 12 + 'px';
  } else {
    html.style.fontSize = 10 + 'px';
  }
  // html.style.fontSize = width / 450  * 16 + "px";
}
calcSize();

// 窗口重置大小时，调用函数修改根标签大小
window.onresize = function () {
  calcSize();
}